import SerakPage from "../../../components/customOrgs/senzacni/SerakPage";

export default function Ramzova() {
    return <SerakPage />;
}
